// extracted by mini-css-extract-plugin
export var section = "screver-in-action-module--section--1lN01";
export var inner = "screver-in-action-module--inner--2MHpU";
export var left = "screver-in-action-module--left--2ui8p";
export var left_svgs = "screver-in-action-module--left_svgs--3L0Xm";
export var animate = "screver-in-action-module--animate--3lqxQ";
export var right = "screver-in-action-module--right--1xeS_";